import Image from "next/image";
import { trpc } from "../../utils/trpc";
import Spinner from "@components/Spinners";

interface Props {
    platform: string;
    size?: number;
    onError?: (e?: any) => void;
    className?: string;
}

// function removes any non alphanumeric characters from a string and lowercases it
const clearText = (text: string | undefined) => {
    if (!text) return "";
    return text.replaceAll(/[^\dA-Za-z]/g, "").toLowerCase();
};

const ExchangeLogo = ({ platform, size, onError, className }: Props) => {
    const { data, isLoading } = trpc.integrations.vezgo.getProviders.useQuery();

    if (isLoading || !data) {
        return <Spinner />;
    }

    const { cexList } = data;
    const clearPlatform = clearText(platform);
    const exchangeLogo = cexList.find((cex) => {
        return (
            clearText(cex.name) === clearPlatform ||
            clearText(cex.display_name) === clearPlatform
        );
    })?.logo;

    return (
        <Image
            src={exchangeLogo ?? "/images/unknown_token.png"}
            width={size ?? 48}
            height={size ?? 48}
            alt={platform}
            className={className}
            onError={onError}
        />
    );
};

export default ExchangeLogo;
